import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Quiz Attempt response
 */
export interface TQuizAttempt {
  id: string;
  quizId: string;
  userId: string;
  attemptNumber: number;
  status: 'in_progress' | 'submitted' | 'graded' | 'abandoned';
  scorePercent: number | null;
  totalPoints: number | null;
  earnedPoints: number | null;
  passed: boolean | null;
  startedAt: string;
  submittedAt: string | null;
  gradedAt: string | null;
  gradedBy: string | null;
  timeSpentSeconds: number | null;
}

/**
 * Hook to start a new quiz attempt
 */
export const useStartAttempt = () => {
  const queryClient = useQueryClient();

  return useMutation<TQuizAttempt, TError, string>({
    mutationFn: async (quizId: string) => {
      const res = await axios.post<TQuizAttempt>(`/community-hub/quizzes/${quizId}/attempts`);
      return res.data;
    },
    onSuccess: (_, quizId) => {
      // Invalidate user attempts cache
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'quiz', quizId, 'attempts'] });
    },
  });
};
